<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    ref="gc-base-layout"
    class="point-of-sale-detail"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        :title="getScreenJson.title"
        :createModeIsEditMode="false"
        :baseView="baseView"
        :primaryLabel="'Point of Sale Transaction # ' + baseView.id"
        v-if="loaded"
      />
    </template>

    <div v-if="loaded" class="css-v2 transaction-screen">
      <div class="gc-header-toolbar">
        <gc-form-header-toolbar
          :toolbar-options="getHeaderToolbar"
          :data-model="{}"
          :itemSaveCallBack="showRefundConfirmation"
          :backRoute="backButtonRoute"
          :setLoading="showLoading"
          ref="gc-form-header-toolbar"
          :baseView="baseView"
          :customButtons="getCustomButtons"
        ></gc-form-header-toolbar>
      </div>
      <div class="gc-data-grid-so-v5">
        <dx-data-grid
          :data-source="getLocalDataSource"
          :columns="getColumns"
          :height="getGridHeight"
          :column-chooser="{ enabled: false }"
          :ref="'dx-data-grid-comp'"
          :key-expr="'ID'"
          :repaint-changes-only="true"
          :show-borders="true"
          :two-way-binding-enabled="false"
          :focusedRowEnabled="true"
          @content-ready="gridContentReady"
          @editing-start="onEditingStart"
          v-if="loaded"
        >
          <DxSearchPanel :visible="false" />
          <DxEditing
            :allow-deleting="false"
            :allow-updating="baseView.mode != 'review'"
            :mode="'cell'"
            :changes="changes"
          />

          <DxKeyboardNavigation
            :edit-on-key-press="true"
            :enter-key-action="'startEdit'"
            :enter-key-direction="'none'"
            :enabled="true"
          />

          <DxPaging :page-size="200" :enabled="false" />

          <DxPager
            :showInfo="true"
            :showPageSizeSelector="false"
            :infoText="'({2} items)'"
            :visible="false"
            class="gc-pager"
            cssClass="gc-pages-2"
          />

          <template #Decimal="{ data }">
            <GcDecimal :dataValue="data" :format="data.column.format" />
          </template>
          <template #DecimalCell="{ data }">
            <GcDecimalCell :dataValue="data" :format="data.column.format" />
          </template>

          <template #include-header-template>
            <!-- :hint="`Update Supplier's Unit Price based upon the price in this Purchase Order`" -->
            <DxCheckBox
              :ref="'include-header-template'"
              :on-value-changed="onIncludeHeaderUpdate"
            />
          </template>

          <template #include-template="{ data: cellInfo }">
            <!-- :hint="`Update Supplier's Unit Price based upon the price in this Purchase Order`" -->
            <DxCheckBox
              :value="cellInfo.data.Include"
              :disabled="cellInfo.data.Status === 'Refunded'"
              :on-value-changed="
                (e) => {
                  if (e.event) onIncludeCheckChanged(e, cellInfo);
                }
              "
            />
          </template>
        </dx-data-grid>
      </div>
    </div>
    <!-- View Receipt Popup Model -->
    <DxPopup
      :visible="visibleReceipt"
      :drag-enabled="true"
      :hide-on-outside-click="false"
      :show-title="true"
      :width="'60%'"
      :height="'75%'"
      :title="'Print Receipt'"
      @hidden="popupHidden"
      @shown="onPrintReceiptShown"
      :showCloseButton="false"
      :wrapper-attr="{ class: 'receipt-popup css-v2 gc-popup' }"
      v-if="visibleReceipt"
    >
      <div v-if="visibleReceipt" class="receipt-content">
        <!-- <iframe :src="receiptURL" title="description"></iframe> -->
        <embed
          :src="receiptURL"
          :width="'100%'"
          :height="'100%'"
          type="application/pdf"
        />
      </div>
      <div class="footer">
        <DxButton
          text="Cancel"
          type="default"
          styling-mode="contained"
          @click="visibleReceipt = false"
        />
      </div>
    </DxPopup>
  </GcBaseLayout>
</template>

<script>
import { mapGetters } from "vuex";

import CheckBox from "devextreme/ui/check_box";
import { custom } from "devextreme/ui/dialog";
import ArrayStore from "devextreme/data/array_store";

import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { PointOfSalesService } from "../../../_services/api/sales/pos/point-of-sale.service";
// import { CustomerReceiptService } from "../../../_services/api/customers/customer-receipt-service";
import ColumnWidth from "../../../_helpers/data-grid/ColumnWidth";
import ApiService from "../../../_services/api/api.service";

import { b64toBlob } from "../../../_helpers/pdf/pdf-helper";
import { TransactionReportService } from "../../../_services/api/reports/transaction-report.service";
import { getGlobalField } from "../../../_store/helpers";

import { CalculateRounding } from "../../../_helpers/formulas/sales-formulas";

export default {
  mixins: [RouteMixin, FormMixin],
  data() {
    return {
      loaded: false,
      gridRenderedOnce: false,
      dataSourcePosDetailList: new ArrayStore({
        key: "ID",
        data: [],
      }),
      changes: [],
      visibleReceipt: false,
      ReceiptCode: undefined,
      receiptURL: undefined,
      TotalRounding: 0,
      PaymentMethod: undefined,
    };
  },
  computed: {
    ...mapGetters({ gridHeight: "ui/getHeightForDataGrid" }),
    getDataGridInstance() {
      return this.$refs["dx-data-grid-comp"].instance;
    },
    getLocalDataSource() {
      return this.dataSourcePosDetailList;
    },
    getRefundTotal() {
      return this.getFXTotal + this.TotalRounding;
    },

    getFXTotal() {
      let total = 0;
      this.dataSourcePosDetailList._array.forEach((line) => {
        if (line.Include && line.Status != "Refunded")
          total = (total + line.FXLineTotal).roundNumber(2);
      });

      return total;
    },

    getTaxTotal() {
      let total = 0;
      this.dataSourcePosDetailList._array.forEach((line) => {
        if (line.Include && line.Status != "Refunded")
          total = (total + line.TaxFXLineTotal).roundNumber(2);
      });

      return total;
    },
    getScreenJson() {
      var screenJson = {
        title: "Point of Sale Details",
      };
      return screenJson;
    },
    getHeaderToolbar() {
      return {
        screenName: "Point of Sale Details",
        pdf: false,
        audit: this.baseView.mode == "review",
        status: false,
        notes: false,
        edit: false,
        save: false,
        editURL: "/sample-request",
        headerFormVisible: true,

        // saveCallback: this.saveBankReconciliation,
        // formContentReady: this.toolBarFormContentReady,
      };
    },
    getHeaderScreenJson() {
      return {
        title: {
          createModeIsEditMode: true,
          primary: {
            primary: {
              dataField: this.baseView.mode != "create" ? "Code" : undefined,
              text:
                this.baseView.mode != "create"
                  ? "Transaction # "
                  : "Create Transaction",
            },
            secondary: {
              dataField: undefined,
              text: undefined,
            },
          },
        },
      };
    },
    getColumns() {
      return [
        {
          caption: "Check",
          dataField: "Include",
          editCellTemplate: "include-template",
          headerCellTemplate: "include-header-template",
          allowEditing: true,
          showEditorAlways: true,
          allowSearch: false,
          allowFiltering: false,
          allowSorting: false,
          width: ColumnWidth.CheckBoxColumn.width,
          minWidth: ColumnWidth.CheckBoxColumn.minWidth,
          setCellValue: async (newData, value) => {
            newData.Include = value;
            return newData;
          },
          visible: true,
        },
        {
          caption: "Product",
          dataField: "ProductDescription",
          cellTemplate: (data, info) => {
            return (data.innerHTML = `<div class="custom-auto-complete">
                        <span class="auto-complete-primary">
                          ${info.data.ProductDescription}
                        </span> <br />
                      <span class="record-secondary gc-grid-code">
                        ${info.data.ItemCode}
                      </span>
                    </div>`);
          },
          allowEditing: false,
        },
        {
          caption: "UM",
          dataField: "SalesUM",
          allowEditing: false,
          width: ColumnWidth.UnitOfMeasure.width,
          minWidth: ColumnWidth.UnitOfMeasure.minWidth,
        },
        {
          caption: "Invoiced",
          dataField: "OriginalSalesUMQty",
          allowEditing: false,
          allowSearch: false,
          allowSorting: false,
          allowFiltering: false,
          format: "##,###,###,###,##0.0000",
          visible: this.baseView.mode != "create",
          cellTemplate: "Decimal",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
        },
        {
          caption: "Refunded",
          dataField: "RefundedQty",

          allowEditing: false,
          allowSearch: false,
          allowSorting: false,
          allowFiltering: false,
          format: "##,###,###,###,##0.0000",
          visible: this.baseView.mode != "create",
          cellTemplate: "Decimal",

          width: ColumnWidth.Quantity4DecimalPoints.width,
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
        },
        {
          caption: "Refund",
          dataField: "RefundQty",
          allowEditing: true,
          allowSearch: false,
          allowSorting: false,
          allowFiltering: false,
          format: "##,###,###,###,##0.0000",
          visible: this.baseView.mode != "create",
          cellTemplate: "DecimalCell",
          editorOptions: {
            format: "##,###,###,###,##0.0000",
            max: 999999999.0,
            maxLength: 9,
            step: 0,
            onFocusIn: (e) => {
              var input = e.element.querySelector("input");
              if (input.value < 0) {
                input.classList.add("gc-state-negative");
                e.element.classList.add("gc-state-negative");
              }
              e.event.target.select();
            },
            onInput: (e) => {
              var inputElement = e.event.target;
              if (inputElement.value.length > 14)
                inputElement.value = inputElement.value.slice(0, 14);
            },
          },
          setCellValue: async (newData, value, currentRowData) => {
            if (value > currentRowData.MaxRefundQty) return;

            newData.RefundQty = value;

            this.updateLineTotals({ ...currentRowData, ...newData }, true);
          },
          width: ColumnWidth.Quantity4DecimalPoints.width,
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
        },
        {
          caption: "Discount",
          dataField: "DiscountPcnt",
          format: "##,###,###,###,##0.00 '%'",
          allowEditing: false,
          width: ColumnWidth.Percentage.width,
          minWidth: ColumnWidth.Percentage.minWidth,
        },
        {
          caption: "Refund Amount",
          dataField: "FXLineTotal",
          gridLabel: "Refund Amount",
          allowEditing: false,
          allowSearch: false,
          allowSorting: false,
          allowFiltering: false,
          format: "##,###,###,###,##0.00",
          visible: this.baseView.mode != "create",
          cellTemplate: "Decimal",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
        },
        {
          caption: "Status",
          dataField: "Status",
          alignment: "right",
          allowEditing: false,
          width: ColumnWidth.POSRefundStatus.width,
          minWidth: ColumnWidth.POSRefundStatus.minWidth,
          cellTemplate: (data, info) => {
            let statusClass = "";

            switch (info.data.Status) {
              case "Processed":
                statusClass = "processed";
                break;
              case "Partially Refunded":
                statusClass = "partially-refunded";
                break;
              case "Refunded":
                statusClass = "fully-refunded";
                break;

              default:
                break;
            }
            return (data.innerHTML = `<div class="refund-status ${statusClass}">
                        <span class="refund-status-text">
                          ${info.data.Status}
                        </span>

                    </div>`);
          },
        },
      ];
    },
    backButtonRoute() {
      return "/point-of-sale-history";
    },
    getCustomButtons() {
      if (this.baseView.mode != "review") {
        let saveOptions = [
          {
            text: "Reprint Receipt",
            onClick: () => {
              this.printReceipt();
            },
            disabled: this.ReceiptCode === undefined,
          },
          {
            text: "Refund",
            onClick: () => {
              this.showRefundConfirmation();
            },
            disabled: this.getFXTotal === 0,
          },
        ];

        return saveOptions;
      } else return [];
    },
    getGridHeight() {
      return this.gridHeight - 76;
    },
    getHeaderCheckboxInstance() {
      var refHeadInstance = this.$refs["include-header-template"].instance;
      refHeadInstance.blur();
      var checkBoxHeader = refHeadInstance.element();
      return CheckBox.getInstance(checkBoxHeader);
    },
  },

  async created() {
    await this.getTransactionDetails();
    this.setPaymentMethod();
    this.loaded = true;
    this.getCashReceiptCode();
  },
  methods: {
    gridContentReady() {
      if (this.gridRenderedOnce === false) {
        this.gridRenderedOnce = true;
        this.focustOnFirstEditableCell();
      }
      setTimeout(() => {
        this.updateHeaderCheckBoxState();
      }, 1);
    },
    backButtonFunction() {
      this.$router
        .push({
          path: this.backButtonRoute,
        })
        .then(() => {
          // this.$store.dispatch("dataContext/setDataViewType", undefined);
        });
    },
    async setPaymentMethod() {
      let result = await PointOfSalesService.getPaymentMethod(this.baseView.id);
      this.PaymentMethod = result.data.value[0].PayMethod;
    },
    async getTransactionDetails() {
      this.dataSourcePosDetailList.clear();
      let result = await PointOfSalesService.getPosTransactionDetails(
        `Invoice eq ${this.baseView.id}`,
        {
          select: [
            "RefundedQty",
            "RefundQty",
            "SalesUM",
            "ProductDescription",
            "ItemCode",
            "OriginalInvoiceLineNo",
            "OriginalSalesUMQty",
            "SalesUMFXPrice",
            "SalesUMNetFXPrice",
            "SalesTaxPcnt",
            "TaxFXLineTotal",
            "DiscountFXLineTotal",
            "DiscountPcnt",
            "FXLineTotal",
            "NetFXLineTotal",
            "Status",
            "WETPcnt",
          ],
        }
      );

      result.data.value.forEach((x, index) => {
        x.ID = index + 1 + new Date().getTime();
        x.Include = false; //  x.Status !== "Refunded";
        x.MaxRefundQty = x.RefundQty;
        x.FXLineTotal = Math.abs(x.FXLineTotal);
        x.TaxFXLineTotal = Math.abs(x.TaxFXLineTotal);
        x.DiscountFXLineTotal = Math.abs(x.DiscountFXLineTotal);
        x.TaxableFXLineTotal = Math.abs(x.TaxableFXLineTotal);
        x.NetFXLineTotal = Math.abs(x.NetFXLineTotal);
        x.RefundQty = 0;

        x.TaxIncSalesUMFXPrice = Math.abs(x.FXLineTotal / x.OriginalSalesUMQty);

        // Check if Refunded Transaction
        if (x.OriginalSalesUMQty < 0) {
          x.RefundedQty = x.OriginalSalesUMQty;
        }

        this.updateLineTotals(x);

        this.dataSourcePosDetailList.insert(x);
      });
    },
    onIncludeHeaderUpdate(e) {
      if (e.event) {
        let dsItems = this.getDataGridInstance.getDataSource().items();

        dsItems.forEach((element) => {
          if (element.Status !== "Refunded") {
            element.Include = e.value;
            if (e.value) {
              element.RefundQty =
                element.OriginalSalesUMQty - element.RefundedQty;

              this.updateLineTotals(element, true);
            } else {
              element.RefundQty = 0;
              element.FXLineTotal = 0;
            }
          }
        });
        this.getDataGridInstance.refresh(true);
      }
    },

    updateLineTotals(gridRow, update) {
      gridRow.SalesUMNetPrice =
        Math.round(
          gridRow.TaxIncSalesUMFXPrice *
            (100 / (100 + gridRow.SalesTaxPcnt)) *
            (100 / (100 + gridRow.WETPcnt)) *
            100
        ) / 100;

      gridRow.SalesUMNetFXPrice = gridRow.SalesUMNetPrice;

      gridRow = this.getUpdateLineTotals(gridRow);

      if (update) {
        this.dataSourcePosDetailList.update(gridRow.ID, gridRow);
        this.getDataGridInstance.refresh(true);
      }
    },

    getUpdateLineTotals(detail) {
      if (detail.WETPcnt === 0 && detail.SalesTaxPcnt === 0) {
        detail.DiscLineTotal = this.roundToTwoDecimals(
          detail.SalesUMFXPrice * detail.RefundQty -
            detail.SalesUMNetPrice * detail.RefundQty
        );
        detail.FXLineTotal = this.roundToTwoDecimals(
          detail.RefundQty * detail.SalesUMNetPrice
        );
        detail.NetLineTotal = this.roundToTwoDecimals(
          detail.RefundQty * detail.SalesUMNetPrice
        );
        detail.LineTotal = this.roundToTwoDecimals(
          detail.SalesUMNetPrice * detail.RefundQty
        );
      } else {
        detail.DiscLineTotal = this.roundToTwoDecimals(
          detail.SalesUMFXPrice * detail.RefundQty -
            detail.SalesUMNetPrice * detail.RefundQty
        );
        detail.FXLineTotal = this.roundToTwoDecimals(
          detail.RefundQty * detail.TaxIncSalesUMFXPrice
        );
        detail.NetLineTotal = this.roundToTwoDecimals(
          detail.RefundQty * detail.SalesUMNetPrice
        );
        detail.LineTotal = this.roundToTwoDecimals(
          detail.TaxIncSalesUMFXPrice * detail.RefundQty
        );
      }

      if (detail.WETPcnt === 0) {
        detail.TaxLineTotal = this.roundToTwoDecimals(
          detail.LineTotal - detail.NetLineTotal
        );
        detail.TaxableLineTotal = detail.NetLineTotal;
        detail.WetLineTotal = this.roundToTwoDecimals(0);
      } else {
        detail.TaxLineTotal = this.roundToTwoDecimals(
          (detail.LineTotal * detail.SalesTaxPcnt) / (detail.SalesTaxPcnt + 100)
        );
        detail.TaxableLineTotal = this.roundToTwoDecimals(
          detail.LineTotal - detail.TaxLineTotal
        );
        detail.WetLineTotal = this.roundToTwoDecimals(
          detail.TaxableLineTotal - detail.NetLineTotal
        );
      }

      detail.DiscFXLineTotal = detail.DiscLineTotal;
      detail.NetFXLineTotal = detail.NetLineTotal;
      detail.TaxFXLineTotal = detail.TaxLineTotal;
      detail.TaxableFXLineTotal = detail.TaxableLineTotal;
      detail.WetFXLineTotal = detail.WetLineTotal;

      return detail;
    },
    roundToTwoDecimals(value) {
      return Math.round(value * 100) / 100;
    },
    onIncludeCheckChanged(e, dataRow) {
      var index = this.getDataGridInstance
        .getDataSource()
        .items()
        .findIndex((x) => x.ID === dataRow.data.ID);

      var gridRow = this.getDataGridInstance.getDataSource().items()[index];
      gridRow.Include = e.value;
      if (e.value === false) {
        gridRow.RefundQty = 0;
        gridRow.FXLineTotal = 0;
      } else {
        gridRow.RefundQty = gridRow.OriginalSalesUMQty - gridRow.RefundedQty;

        this.updateLineTotals(gridRow, true);
        this.focusOnEditableCell(index, "RefundQty");
      }
      this.getDataGridInstance.refresh(true);
    },
    focustOnFirstEditableCell() {
      let editableRowIndex = this.getDataGridInstance
        .getDataSource()
        .items()
        .findIndex((x) => x.Include === true);

      if (editableRowIndex !== -1) {
        this.focusOnEditableCell(editableRowIndex, "RefundQty");
      }
    },
    updateHeaderCheckBoxState() {
      let dsItems = this.getDataGridInstance.getDataSource().items();
      let includedItems = dsItems.filter((x) => x.Include);

      if (includedItems.length == 0)
        this.getHeaderCheckboxInstance.option("value", false);
      else if (includedItems.length == dsItems.length)
        this.getHeaderCheckboxInstance.option("value", true);
      else this.getHeaderCheckboxInstance.option("value", undefined);
    },
    showRefundConfirmation() {
      if (this.PaymentMethod === "CASH") {
        this.TotalRounding = CalculateRounding(this.getFXTotal);
      }

      this.$nextTick(function () {
        let myDialog = custom({
          title: "Refund Item",
          messageHtml: `<p class="refund-maintext">Refund amount </p> <p class="refund-amount">$${this.getRefundTotal.toFixed(
            2
          )}</p> 
          <p class="refund-rounding"> Rounding <span class="amount"> (${this.TotalRounding.toFixed(
            2
          )})</span></p>
          
          <p class="refund-confirmation">Are you sure to proceed with this refund? Please check the details above.</p>`,
          buttons: [
            {
              text: "Cancel",
              elementAttr: {
                class: "cancel",
              },
              onClick: (e) => {
                return { buttonText: e.component.option("text") };
              },
            },
            {
              text: "Refund",
              elementAttr: {
                class: "refund",
              },
              onClick: (e) => {
                return { buttonText: e.component.option("text") };
              },
            },
          ],
        });
        myDialog.show().then(async (dialogResult) => {
          if (dialogResult.buttonText == "Refund") {
            await this.performRefund();
          }
        });
      });
    },

    async performRefund() {
      let originalInvoiceCode = this.baseView.id;
      let payload = {
        OriginalInvoiceCode: originalInvoiceCode,
        DateIn: new Date().toSaveDate(),
        FXTotal: -1 * this.getFXTotal,
        TaxTotal: -1 * this.getTaxTotal,
        Rounding: this.TotalRounding,
        RefundOrderDetails: [],
      };

      this.dataSourcePosDetailList._array.forEach((line, index) => {
        if (line.Include && line.Status != "Refunded")
          payload.RefundOrderDetails.push({
            OriginalInvoiceCode: originalInvoiceCode,
            OriginalInvoiceLineNo: line.OriginalInvoiceLineNo,
            LineNoSequence: index + 1,
            RefundQty: line.RefundQty,
            FXLineTotal: -1 * line.FXLineTotal,
            DiscFXLineTotal: -1 * line.DiscountFXLineTotal,
            NetFXLineTotal: -1 * line.NetFXLineTotal,
            TaxFXLineTotal: -1 * line.TaxFXLineTotal,
            TaxableFXLineTotal: -1 * line.TaxableFXLineTotal,
          });
      });

      if (payload.RefundOrderDetails.length === 0) {
        this.$notify(
          `Refund has no detail.  Please refund one or more lines before attempting to save the transaction again.`,
          "error"
        );

        return;
      }

      this.showLoading(true);

      await PointOfSalesService.savePOSRefund(payload)
        .then(async (res) => {
          if (res) this.showLoading(false);
          this.$notify(
            `Successfully refunded Transaction #${this.baseView.id}`,
            "success"
          );

          this.showLoading(false);
          this.setIgnoreRouteChangeConfirmation();

          await this.getTransactionDetails();
          this.getDataGridInstance.refresh(true);
          // this.backButtonFunction();
        })
        .catch((error) => {
          this.showLoading(false);
          this.displayServerError(error, "Purchase order failed to complete");
        });
    },
    printReceipt() {
      // alert("Reprint Receipt - will be implmented soon");
      this.visibleReceipt = true;
    },
    onEditingStart(e) {
      if (e.data.Include === false) {
        e.cancel = true;
      }
    },
    focusOnEditableCell(rowIndex, col) {
      var columnName = col ? col : "RefundQty";
      var dataGrid = this.$refs["dx-data-grid-comp"].instance;

      var cellElement = dataGrid.getCellElement(rowIndex, columnName);
      dataGrid.focus(cellElement);
      this.$nextTick(() => {
        dataGrid.editCell(rowIndex, columnName);
      });
    },
    popupHidden() {
      this.visibleReceipt = false;
    },
    async onPrintReceiptShown() {
      if (!this.ReceiptCode) return;
      var response;
      await TransactionReportService.getByFeatureCode("ReportPOSInvoice")
        .then((res) => {
          response = res;
        })
        .catch((err) => {
          if (err) this.displayServerError(err, "Report repx not found");
        });

      var report = undefined;
      if (response && response.data) {
        report = response.data;
        report.Parameters = JSON.parse(response.data.Parameters);

        let link = `/api/GetReportPdf?reportLocation=${report.Location}`;

        report.Parameters.forEach((element) => {
          let globalField = { ...getGlobalField(element.screenField) };

          if (globalField) {
            link += `&${globalField.dataField}=${this.ReceiptCode}`;
          }
        });

        this.showLoading(true);
        await ApiService.get(link)
          .then((res) => {
            const blob = b64toBlob(res.data, "application/pdf");
            const blobUrl = URL.createObjectURL(blob);
            this.showLoading(false);

            this.receiptURL = Object.assign(document.createElement("a"), {
              href: blobUrl,
            });
          })
          .catch((error) => {
            this.$logger.debug("ExportToPdf Error ", error);
            this.showLoading(false);
          });
      }
    },

    async getCashReceiptCode() {
      // await CustomerReceiptService.getCashReceiptDetail({
      //   filter: ["Invoice eq " + `'${this.baseView.id}'`],
      //   select: ["CashReceiptCode"],
      // }).then((res) => {
      //   if (res.data.value.length > 0)
      //     this.ReceiptCode = res.data.value[0].CashReceiptCode;
      // });

      this.ReceiptCode = this.baseView.id;
    },
  },
};
</script>

<style lang="scss">
.point-of-sale-detail {
  .processed {
    color: green;
  }

  .partially-refunded {
    color: orange;
  }

  .fully-refunded {
    color: red;
  }

  .dx-button.dx-state-disabled .dx-button-text {
    color: rgba($color: #ffffff, $alpha: 0.35);
  }

  .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    > td:first-of-type:not(.dx-command-expand) {
    padding: 0px !important;
    margin: 0px !important;
  }

  .gc-header-toolbar {
    .dx-button[aria-label="Reprint Receipt"] {
      background-color: #03a9f4;
      color: #fff !important;
      .dx-button-content .dx-icon::before {
        color: #fff !important;
      }
    }
    .dx-button[aria-label="Refund"] {
      background-color: #ff0000;
      color: #fff;
      .dx-button-content .dx-icon::before {
        color: #fff !important;
      }
    }
  }

  // dx-widget dx-button dx-button-mode-text dx-button-default dx-button-has-text refund dx-dialog-button
}

.dx-dialog-buttons {
  .dx-button[aria-label="Refund"] {
    background-color: #ff0000;
    color: #fff;
    .dx-button-content .dx-icon::before {
      color: #fff !important;
    }
  }

  .dx-button[aria-label="Cancel"] {
    color: #9a9ca5;
    background-color: #f3f3f3;
    border-color: #f3f3f3;
  }
}
.dx-dialog {
  .refund-maintext {
    text-align: center;
    margin: 0 0 5px 0;
  }

  .refund-rounding {
    font-size: 0.8rem;
    text-align: center;
    margin: 8px 0 5px 0;

    .amount {
      font-weight: bold;
    }
  }

  .refund-amount {
    font-weight: bold;
    font-size: 1rem;
    text-align: center;
    margin: 0;
  }

  .refund-confirmation {
    text-align: center;
  }
}
.receipt-popup {
  .dx-popup-content {
    padding: 12px !important;
    .receipt-content {
      background-color: white;
      padding: 12px;
      height: calc(100% - 40px);
      margin-bottom: 12px;
    }

    .footer {
      padding-right: 0 !important;
      height: 40px;
    }
  }
}
</style>
